<template>
  <div
    ref="kt_modal_tributacoes_consultar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_tributacoes_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="card">
            <div class="card-header">
              <div class="card-title d-flex align-items-center">
                <h3 class="fw-bold m-0 text-gray-800">Tributações</h3>
              </div>
              <div
                class="btn btn-icon btn-sm btn-active-light-primary mt-6"
                data-bs-dismiss="modal"
                @click="this.$emit('exibirModalTributacoes', false)"
              >
                <span class="svg-icon svg-icon-1 svg-icon lh-0">
                  <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                </span>
              </div>
            </div>
            <div class="card-body p-0">
              <div
                v-if="this.errosValidacaoGeral.length"
                class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
              >
                <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                  <inline-svg src="media/icons/duotune/general/gen044.svg" />
                </span>
                <div class="d-flex flex-stack flex-grow-1">
                  <div class="fw-bold">
                    <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                    <div class="fs-6 text-gray-600">
                      <ul>
                        <li
                          v-for="value in this.errosValidacaoGeral"
                          :key="value"
                        >
                          {{ value }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-header border-0 pt-5">
                <div class="card-title">
                  <div class="d-flex align-items-center position-relative my-1">
                    <span class="svg-icon svg-icon-1 position-absolute ms-6">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                    <input
                      type="text"
                      id="txtPesquisarTributacoes"
                      v-model="tableData.search"
                      @input="onSearch($event.target.value)"
                      class="form-control form-control-solid w-250px ps-15"
                      placeholder="Pesquisar Tributações"
                    />
                  </div>
                </div>
                <div class="card-toolbar">
                  <div
                    v-if="checkedTributacoes.length === 0"
                    class="d-flex justify-content-end"
                    data-kt-customer-table-toolbar="base"
                  >
                    <button
                      v-if="this.adicionar"
                      @click="adicionarTributacao()"
                      class="btn btn-sm btn-primary"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/general/gen041.svg" /></span
                      >Adicionar
                    </button>
                  </div>
                  <div
                    v-else
                    class="d-flex justify-content-end align-items-center"
                    data-kt-customer-table-toolbar="selected"
                  >
                    <div class="fw-bolder me-5">
                      <span class="me-2">{{ checkedTributacoes.length }}</span
                      >Selecionado(s)
                    </div>
                    <button
                      v-if="this.excluir"
                      type="button"
                      class="btn btn-sm btn-danger"
                      @click="deleteSelecionados()"
                    >
                      Excluír Selecionado(s)
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <Datatable
                  ref="table"
                  :table-header="tableHeader"
                  :table-data="tableData"
                  :table-pagination="tablePagination"
                  :page-sizes="pageSizes"
                  :enable-items-per-page-dropdown="true"
                  :hide-on-single-page="false"
                  empty-table-text="Nenhuma tributacão encontrada"
                  v-on:checked-rows="checkedTributacoes = $event"
                >
                  <template v-slot:cell-checkbox="{ row: tributacoes }">
                    <div
                      class="form-check form-check-sm form-check-custom form-check-solid"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="tributacoes.id"
                        v-model="checkedTributacoes"
                      />
                    </div>
                  </template>
                  <template v-slot:cell-id="{ row: tributacoes }">
                    {{ tributacoes.id }}
                  </template>
                  <template v-slot:cell-descricao="{ row: tributacoes }">
                    {{ tributacoes.descricao }}
                  </template>
                  <template v-slot:cell-tipo_tributacao="{ row: tributacoes }">
                    {{ tributacoes.tipo_tributacao }}
                  </template>
                  <template v-slot:cell-acoes="{ row: tributacoes }">
                    <div class="min-w-200px">
                      <button
                        type="button"
                        class="btn btn-sm btn-light btn-light-primary my-2 me-2"
                        data-bs-dismiss="modal"
                        @click="$emit('selecionarTributacao', tributacoes)"
                      >
                        Selecionar
                      </button>
                      <button
                        class="btn btn-sm btn-light btn-active-light-primary"
                        data-kt-menu-trigger="click"
                        data-kt-menu-placement="bottom-end"
                        data-kt-menu-flip="top-end"
                      >
                        Ações
                        <span class="svg-icon svg-icon-5 m-0">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr072.svg"
                          />
                        </span>
                      </button>
                      <div
                        v-if="this.editar || this.excluir"
                        class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                        data-kt-menu="true"
                      >
                        <div v-if="this.editar" class="menu-item px-3">
                          <a
                            @click="editarTributacao(tributacoes)"
                            class="menu-link px-3"
                            >Editar</a
                          >
                        </div>
                        <div v-if="this.excluir" class="menu-item px-3">
                          <a
                            @click="removerRegistro(tributacoes.id)"
                            class="menu-link px-3"
                            >Excluír</a
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:cell-icms="{ row: tributacoes }">
                    {{ tributacoes.icms }}
                  </template>
                  <template v-slot:cell-st="{ row: tributacoes }">
                    {{ tributacoes.st }}
                  </template>
                  <template v-slot:cell-csosn="{ row: tributacoes }">
                    {{ tributacoes.csosn }}
                  </template>
                  <template v-slot:cell-reducao="{ row: tributacoes }">
                    {{ this.$utils.formatarNumero(tributacoes.reducao) }}
                  </template>
                  <template v-slot:cell-mva="{ row: tributacoes }">
                    {{ this.$utils.formatarNumero(tributacoes.mva) }}
                  </template>
                </Datatable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="exibirEditarTributacao"
    id="kt_modal_tributacao_editar"
    ref="kt_modal_tributacao_editar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.tributacoes.id === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Tributação
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Tributação
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.modalEditarTributacao(false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
            >
              <div class="mb-10 fv-row">
                <label class="form-label">Descrição</label>
                <input
                  id="txtDescricaoTributacao"
                  type="text"
                  class="form-control mb-2"
                  maxlength="60"
                  :value="
                    (tributacoes.descricao =
                      tributacoes.descricao.toUpperCase())
                  "
                  @input="
                    tributacoes.descricao = $event.target.value.toUpperCase()
                  "
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["descricao"] }}
                </div>
              </div>
            </div>
          </div>
          <el-divider content-position="left"
            ><h4 class="text-primary">ICMs/IPI</h4></el-divider
          >
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-7 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Tipo de Tributação</label>
                <select
                  class="form-select mb-2"
                  data-control="select2"
                  data-hide-search="true"
                  data-placeholder="Selecione uma opção"
                  @change="this.atualizaTipoTributacao($event.target.value)"
                  v-model="this.tributacoes.tipo_tributacao"
                >
                  <option value="Normal" selected="selected">Normal</option>
                  <option value="Substituição Tributária">
                    Substituição Tributária
                  </option>
                  <option value="Isenção">Isenção</option>
                  <option value="Não Incidência">Não Incidência</option>
                  <option value="ISS">ISS</option>
                </select>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["tipo_tributacao"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-3 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">S.T</label>
                <div class="input-group mb-2">
                  <input
                    id="txtST"
                    type="text"
                    class="form-control"
                    v-model="this.tributacoes.st"
                    maxlength="3"
                  />
                  <button
                    type="button"
                    class="input-group-text"
                    @click="this.modalST(true)"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                  </button>
                </div>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["st"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-3 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">CSOSN</label>
                <div class="input-group mb-2">
                  <input
                    id="txtCSOSN"
                    type="text"
                    class="form-control"
                    v-model="this.tributacoes.csosn"
                    maxlength="4"
                  />
                  <button
                    type="button"
                    class="input-group-text"
                    @click="this.modalCSOSN(true)"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                  </button>
                </div>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["csosn"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-7 col-xxl-6 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Clas. Fiscal</label>
                <input
                  id="txtClasFiscal"
                  type="text"
                  class="form-control mb-2"
                  v-model="this.tributacoes.classificacao_fiscal"
                />
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["classificacao_fiscal"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">% Imposto</label>
                <CurrencyInput
                  class="form-control mb-2"
                  placeholder="% Imposto"
                  style="text-align: right"
                  v-model="this.tributacoes.por_imposto_prod"
                  :options="options"
                ></CurrencyInput>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["por_imposto_prod"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Aliq. ICMs %</label>
                <select
                  class="form-select mb-0"
                  data-placeholder="Selecione uma opção"
                  v-model="this.tributacoes.icms"
                >
                  <template v-for="aliquota in this.aliquotas" :key="aliquota">
                    <option
                      :value="aliquota.aliquota"
                      v-bind:selected="[
                        aliquota.aliquota === this.tributacoes.icms
                          ? 'selected'
                          : '',
                      ]"
                    >
                      {{ aliquota.aliquota }}
                    </option>
                  </template>
                </select>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["icms"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">% MVA</label>
                <CurrencyInput
                  class="form-control mb-2"
                  placeholder="% MVA"
                  style="text-align: right"
                  v-model="this.tributacoes.mva"
                  :options="options"
                ></CurrencyInput>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["mva"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">% Redução</label>
                <CurrencyInput
                  class="form-control mb-2"
                  placeholder="% Redução"
                  style="text-align: right"
                  v-model="this.tributacoes.reducao"
                  :options="options"
                ></CurrencyInput>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["reducao"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">% IPI</label>
                <CurrencyInput
                  class="form-control mb-2"
                  placeholder="% IPI"
                  style="text-align: right"
                  v-model="this.tributacoes.ipi"
                  :options="options"
                ></CurrencyInput>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["ipi"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">C.F.O.P</label>
                <div class="input-group mb-2">
                  <input
                    id="txtCFOP"
                    type="text"
                    class="form-control"
                    v-model="this.tributacoes.cfop"
                    readonly
                  />
                  <button
                    type="button"
                    class="input-group-text"
                    @click="this.modalCfops(true)"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                  </button>
                </div>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["cfop"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Aliq. Interna</label>
                <select
                  class="form-select mb-0"
                  data-placeholder="Selecione uma opção"
                  v-model="this.tributacoes.aliqi"
                >
                  <template v-for="aliquota in this.aliquotas" :key="aliquota">
                    <option
                      :value="aliquota.aliquota"
                      v-bind:selected="[
                        aliquota.aliquota === this.tributacoes.aliqi
                          ? 'selected'
                          : '',
                      ]"
                    >
                      {{ aliquota.aliquota }}
                    </option>
                  </template>
                </select>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["aliqi"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">Tabela de Estados</label>
                <div class="input-group mb-2">
                  <input
                    id="txtTabelaEstados"
                    type="text"
                    class="form-control"
                    v-model="this.tributacoes.id_estoque_st"
                    readonly
                  />
                  <span
                    class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                    @click="limparTabelaEstados()"
                  >
                    <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                  </span>
                  <button
                    type="button"
                    class="input-group-text"
                    @click="this.modalTabelaEstados(true)"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                  </button>
                </div>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["id_estoque_st"] }}
                </div>
              </div>
            </div>
          </div>
          <el-divider content-position="left"
            ><h4 class="text-primary">PIS - Operações de Saída</h4></el-divider
          >
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-9 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label"
                  >Código da Situação Tributária ao PIS</label
                >
                <select
                  class="form-select mb-2"
                  data-control="select2"
                  data-hide-search="true"
                  data-placeholder="Selecione uma opção"
                  v-model="this.tributacoes.pis_st"
                >
                  <option value="01" selected="selected">
                    01 - Operação Tributável com Alíquota Básica
                  </option>
                  <option value="02">
                    02 - Operação Tributável com Alíquota Diferenciada
                  </option>
                  <option value="03">
                    03 - Operação Tributável com Alíquota por Unidade de Medida
                    de Produto
                  </option>
                  <option value="04">
                    04 - Operação Tributável Monofásica - Revenda a Alíquota
                    Zero
                  </option>
                  <option value="05">
                    05 - Operação Tributável por Substituição Tributária
                  </option>
                  <option value="06">
                    06 - Operação Tributável a Alíquota Zero
                  </option>
                  <option value="07">
                    07 - Operação Isenta da Contribuição
                  </option>
                  <option value="08">
                    08 - Operação sem Incidência da Contribuição
                  </option>
                  <option value="09">
                    09 - Operação com Suspensão da Contribuição
                  </option>
                  <option value="49">49 - Outras Operações de Saída</option>
                  <option value="99">99 - Outras Operações</option>
                </select>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["pis_st"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">% PIS</label>
                <CurrencyInput
                  class="form-control mb-2"
                  placeholder="% PIS"
                  style="text-align: right"
                  v-model="this.tributacoes.pis_aliq"
                  :options="options"
                ></CurrencyInput>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["pis_aliq"] }}
                </div>
              </div>
            </div>
          </div>
          <el-divider content-position="left"
            ><h4 class="text-primary">
              COFINS - Operações de Saída
            </h4></el-divider
          >
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-9 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label"
                  >Código da Situação Tributária ao COFINS</label
                >
                <select
                  class="form-select mb-2"
                  data-control="select2"
                  data-hide-search="true"
                  data-placeholder="Selecione uma opção"
                  v-model="this.tributacoes.cofins_st"
                >
                  <option value="01" selected="selected">
                    01 - Operação Tributável com Alíquota Básica
                  </option>
                  <option value="02">
                    02 - Operação Tributável com Alíquota Diferenciada
                  </option>
                  <option value="03">
                    03 - Operação Tributável com Alíquota por Unidade de Medida
                    de Produto
                  </option>
                  <option value="04">
                    04 - Operação Tributável Monofásica - Revenda a Alíquota
                    Zero
                  </option>
                  <option value="05">
                    05 - Operação Tributável por Substituição Tributária
                  </option>
                  <option value="06">
                    06 - Operação Tributável a Alíquota Zero
                  </option>
                  <option value="07">
                    07 - Operação Isenta da Contribuição
                  </option>
                  <option value="08">
                    08 - Operação sem Incidência da Contribuição
                  </option>
                  <option value="09">
                    09 - Operação com Suspensão da Contribuição
                  </option>
                  <option value="49">49 - Outras Operações de Saída</option>
                  <option value="99">99 - Outras Operações</option>
                </select>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["cofins_st"] }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2">
              <div class="mb-10 fv-row">
                <label class="form-label">% COFINS</label>
                <CurrencyInput
                  class="form-control mb-2"
                  placeholder="% COFINS"
                  style="text-align: right"
                  v-model="this.tributacoes.cofins_aliq"
                  :options="options"
                ></CurrencyInput>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["cofins_aliq"] }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
            >
              <h4 class="text-primary ms-4">Sped</h4>
              <div
                class="card border border-rounded border-gray-300 mb-4 mt-4 p-6"
              >
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 mb-2"
                  >
                    <div class="mb-4 fv-row">
                      <label class="form-label">Gênero do produto</label>
                      <div class="input-group mb-2">
                        <input
                          id="txtCodGenero"
                          type="text"
                          class="form-control"
                          v-model="this.tributacoes.cod_genero"
                          readonly
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalGeneroSpeds(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["cod_genero"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-8 mb-2"
                  >
                    <div class="mb-4 fv-row">
                      <label class="form-label">Tipo do produto</label>
                      <select
                        class="form-select mb-2"
                        data-control="select2"
                        data-hide-search="true"
                        data-placeholder="Selecione uma opção"
                        v-model="this.tributacoes.tipo_produto"
                      >
                        <option value="00" selected="selected">
                          00 - Mercadoria para revenda
                        </option>
                        <option value="01">01 - Matéria-Prima</option>
                        <option value="02">02 - Embalagem</option>
                        <option value="03">03 - Produto em Processo</option>
                        <option value="04">04 - Produto Acabado</option>
                        <option value="05">05 - Subproduto</option>
                        <option value="06">06 - Produto Intermediário</option>
                        <option value="07">
                          07 - Material de Uso e Consumo
                        </option>
                        <option value="08">08 - Ativo Imobilizado</option>
                        <option value="09">09 - Serviços</option>
                        <option value="10">10 - Outros Insumos</option>
                        <option value="99">99 - Outras</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["tipo_produto"] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="this.modalEditarTributacao(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            id="btnConfirmarTributacao"
            @click="confirmarTributacao()"
            v-bind:data-kt-indicator="this.loadingTributacao ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loadingTributacao">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <STModal
    v-if="exibirST"
    :st="this.tributacoes.st"
    @exibirModalST="modalST"
    @confirmarST="confirmarST"
  ></STModal>
  <CSOSNModal
    v-if="exibirCSOSN"
    :csosn="this.tributacoes.csosn"
    @exibirModalCSOSN="modalCSOSN"
    @confirmarCSOSN="confirmarCSOSN"
  ></CSOSNModal>
  <CfopsModal
    v-if="exibirCfops"
    @exibirModalCfops="modalCfops"
    @selecionarCfop="selecionarCfop"
  ></CfopsModal>
  <TabelaEstadosModal
    v-if="exibirTabelaEstados"
    @exibirModalTabelaEstados="modalTabelaEstados"
    @selecionarTabelaEstado="selecionarTabelaEstado"
  ></TabelaEstadosModal>
  <GeneroSpedsModal
    v-if="exibirGeneroSpeds"
    @exibirModalGeneroSpeds="modalGeneroSpeds"
    @selecionarGeneroSped="selecionarGeneroSped"
  ></GeneroSpedsModal>
</template>

<script>
import STModal from "../produtos/STModal.vue";
import CSOSNModal from "../produtos/CSOSNModal.vue";
import CfopsModal from "../produtos/CfopsModal.vue";
import TabelaEstadosModal from "../produtos/TabelaEstadosModal.vue";
import GeneroSpedsModal from "../produtos/GeneroSpedsModal.vue";
import CurrencyInput from "@/components/text/CurrencyInput";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
import {
  hideModal,
  hideModalId,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";

export default {
  emits: ["exibirModalTributacoes", "selecionarTributacao"],
  components: {
    Datatable,
    STModal,
    CSOSNModal,
    CfopsModal,
    TabelaEstadosModal,
    GeneroSpedsModal,
    CurrencyInput,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    selecionarGeneroSped(generoSped) {
      this.tributacoes.cod_genero = generoSped.codigo;
      this.modalGeneroSpeds(false);
    },
    modalGeneroSpeds(exibir) {
      this.exibirGeneroSpeds = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_genero_speds_consultar");
        }, 100);
      }
    },
    limparTabelaEstados() {
      this.tributacoes.id_estoque_st = null;
    },
    selecionarTabelaEstado(estoqueSt) {
      this.tributacoes.id_estoque_st = estoqueSt.id;
      this.modalTabelaEstados(false);
    },
    modalTabelaEstados(exibir) {
      this.exibirTabelaEstados = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_tabela_estados_consultar");
        }, 100);
      }
    },
    selecionarCfop(cfop) {
      this.tributacoes.cfop = cfop.codigo;
      this.modalCfops(false);
    },
    modalCfops(exibir) {
      this.exibirCfops = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_cfops_consultar");
        }, 100);
      }
    },
    async carregarAliquotas() {
      try {
        var ret = await this.$store.dispatch("aliquota/getAliquotaOData", "");
        if (ret.value !== null && ret.value.length > 0) {
          this.aliquotas = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    confirmarCSOSN(csosn) {
      this.tributacoes.csosn = csosn;
      this.modalCSOSN(false);
    },
    modalCSOSN(exibir) {
      this.exibirCSOSN = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_csosn_consultar");
        }, 100);
      }
    },
    confirmarST(st) {
      this.tributacoes.st = st;
      this.modalST(false);
    },
    modalST(exibir) {
      this.exibirST = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_st_consultar");
        }, 100);
      }
    },
    atualizaTipoTributacao(tipo) {
      if (tipo === "Normal") {
        this.tributacoes.st = "000";
        this.tributacoes.csosn = "0102";
      } else if (tipo === "Substituição Tributária") {
        this.tributacoes.st = "060";
        this.tributacoes.csosn = "0500";
      } else if (tipo === "Isenção") {
        this.tributacoes.st = "040";
        this.tributacoes.csosn = "0103";
      } else if (tipo === "Não Incidência") {
        this.tributacoes.st = "041";
        this.tributacoes.csosn = "0400";
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(descricao, '" + pesquisa + "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    async deleteSelecionados() {
      var alert = await Swal.fire({
        text: "Deseja remover os registros selecionados?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.table.setLoading(true);
        for (var i = 0; i < this.checkedTributacoes.length; i++) {
          await this.excluirTributacao(this.checkedTributacoes[i]);
        }
        if (this.excluiuCadastro === true) {
          toast.success("Tributações excluídas com sucesso!", {
            timeout: 3000,
          });
        }
        this.$refs.table.load();
      }
    },
    async removerRegistro(id) {
      var alert = await Swal.fire({
        text: "Deseja remover o registro?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.table.setLoading(true);
        await this.excluirTributacao(id);
        if (this.excluiuCadastro === true) {
          toast.success("Tributação excluída com sucesso!", { timeout: 3000 });
        }
        this.$refs.table.load();
      }
    },
    async excluirTributacao(id) {
      try {
        await this.$store.dispatch("tributacoes/deleteTributacoes", id);
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    modalEditarTributacao(exibir) {
      this.exibirEditarTributacao = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_tributacao_editar");
        }, 100);
        setTimeout(() => {
          this.nextFocus("txtDescricaoTributacao");
        }, 500);
      }
    },
    adicionarTributacao() {
      this.tributacoes = {
        id: 0,
        descricao: "",
        tipo_tributacao: "Normal",
        st: "000",
        csosn: "0102",
        classificacao_fiscal: "",
        por_imposto_prod: 0,
        icms: "00,00",
        mva: 0,
        reducao: 0,
        ipi: 0,
        pis_st: "49",
        pis_aliq: 0,
        cofins_st: "49",
        cofins_aliq: 0,
        cfop: null,
        cod_genero: "0",
        aliqi: "00,00",
        id_estoque_st: null,
        tipo_produto: "00",
        ncm: "",
      };
      this.modalEditarTributacao(true);
    },
    async editarTributacao(tributacoes) {
      try {
        var ret = await this.$store.dispatch(
          "tributacoes/getTributacoes",
          tributacoes.id
        );
        if (ret.Success === true) {
          this.tributacoes = ret.Data;
          this.modalEditarTributacao(true);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async confirmarTributacao() {
      this.errosValidacao = [];
      this.loadingTributacao = true;
      this.tributacoes.cfop = this.tributacoes.cfop
        ? this.tributacoes.cfop
        : null;
      this.tributacoes.cod_genero = this.tributacoes.cod_genero
        ? this.tributacoes.cod_genero.toString()
        : null;
      if (this.tributacoes.id === 0) {
        try {
          var ret = await this.$store.dispatch(
            "tributacoes/postTributacoes",
            this.tributacoes
          );
          if (ret.Success === true) {
            toast.success("Tributação cadastrada com sucesso!", {
              timeout: 3000,
            });
            hideModalId("kt_modal_tributacao_editar");
            this.modalEditarTributacao(false);
            this.$refs.table.load();
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch(
            "tributacoes/putTributacoes",
            this.tributacoes
          );
          if (retPut.Success === true) {
            toast.success("Tributação alterada com sucesso!", {
              timeout: 3000,
            });
            hideModalId("kt_modal_tributacao_editar");
            this.modalEditarTributacao(false);
            this.$refs.table.load();
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      }
      this.loadingTributacao = false;
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Tributacoes.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.Tributacoes.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.Tributacoes.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
  },
  async mounted() {
    this.verificarRestricoes();
    setTimeout(() => {
      this.nextFocus("txtPesquisarTributacoes");
    }, 800);
    this.carregarAliquotas();
  },
  data() {
    return {
      exibirEditarTributacao: false,
      exibirGeneroSpeds: false,
      exibirTabelaEstados: false,
      exibirCfops: false,
      aliquotas: [],
      exibirST: false,
      exibirCSOSN: false,
      loadingTributacao: false,
      tributacoes: {
        id: 0,
        descricao: "",
        tipo_tributacao: "Normal",
        st: "000",
        csosn: "0102",
        classificacao_fiscal: "",
        por_imposto_prod: 0,
        icms: "00,00",
        mva: 0,
        reducao: 0,
        ipi: 0,
        pis_st: "49",
        pis_aliq: 0,
        cofins_st: "49",
        cofins_aliq: 0,
        cfop: null,
        cod_genero: "0",
        aliqi: "00,00",
        id_estoque_st: null,
        tipo_produto: "00",
        ncm: "",
      },
      adicionar: false,
      editar: false,
      excluir: false,
      checkedTributacoes: [],
      errosValidacaoGeral: [],
      errosValidacao: {},
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Descrição",
          key: "descricao",
          sortable: true,
        },
        {
          name: "Tributação",
          key: "tipo_tributacao",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
        {
          name: "ICMS",
          key: "icms",
          sortable: true,
        },
        {
          name: "ST",
          key: "st",
          sortable: true,
        },
        {
          name: "CSOSN",
          key: "csosn",
          sortable: true,
        },
        {
          name: "Redução",
          key: "reducao",
          sortable: true,
        },
        {
          name: "Margem",
          key: "mva",
          sortable: true,
        },
      ],
      tableData: {
        store: "tributacoes/getTributacoesOData",
        selectOData:
          "?$select=id,descricao,tipo_tributacao,icms,st,csosn,reducao,mva",
        filterOData: "",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style></style>
